import Login from "../views/Login.svelte";
import AsList from "../views/AsList.svelte";
import AsForm from "../views/AsForm.svelte";
import AsPartner from "../views/AsPartner.svelte";
import AsRepair from "../views/AsRepair.svelte";
import AsTime from "../views/AsTime.svelte";
import AsTimeComplete from "../views/AsTimeComplete.svelte";
import PartnerList from "../views/PartnerList.svelte";
import PartnerDetail from "../views/PartnerDetail.svelte";
import AsDetail from "../views/AsDetail.svelte";
import NotFound from "../views/NotFound.svelte";
import Temp from "../views/Temp.svelte";

export default {
    "/": Login,
    "/Login": Login,
    "/AsList": AsList,
    "/AsForm": AsForm,
    "/AsPartner/:as_id": AsPartner,
    "/AsRepair/:as_id/:as_cmpn_id": AsRepair,
    "/AsTime/:as_id/:as_cmpn_id/:repair_id/:repair_name/:phone": AsTime,
    "/AsTimeComplete": AsTimeComplete,
    "/PartnerList": PartnerList,
    "/PartnerDetail/:cmpn_id": PartnerDetail,
    "/AsDetail/:as_id": AsDetail,
    "/Temp": Temp,
    "*": NotFound,
};
